<div class="progress-wrapper" [ngClass]="{light:lightMode}">
    <div class="item-count" *ngIf="currentItem && maxItems">{{ currentItem + '/' + maxItems}}</div>
    <mat-progress-bar class="default-progress" color="primary" mode="determinate" [value]="value"></mat-progress-bar>
    <div class="progress-value">{{ value || '0' }}%</div>
</div>